<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title text-center">Create an Account</h5>
            <form @submit.prevent="register">
              <div class="mb-3">
                <label for="username" class="form-label">Username</label>
                <input type="text" 
                       class="form-control" 
                       v-model="username"
                       data-testid="username-input"
                       @input="validateUsername" 
                       placeholder="Choose a username" 
                       required>
                <div class="text-danger" v-if="usernameError">{{ usernameError }}</div>
                <div class="text-danger" v-if="usernameWarning">{{ usernameWarning }}</div>
              </div>
              <div class="mb-3">
                <label for="first-name" class="form-label">First Name</label>
                <input type="text" 
                       class="form-control" 
                       v-model="firstName" 
                       @input="validateFirstName" 
                       required>
                <div class="text-danger" v-if="firstNameError">{{ firstNameError }}</div>
              </div>
              <div class="mb-3">
                <label for="last-name" class="form-label">Last Name</label>
                <input type="text" 
                       class="form-control" 
                       v-model="lastName" 
                       @input="validateLastName" 
                       required>
                <div class="text-danger" v-if="lastNameError">{{ lastNameError }}</div>
              </div>
              <div class="mb-3">
                <label for="birth-date" class="form-label">Birth Date</label>
                <input type="date" 
                       class="form-control" 
                       v-model="birthDate" 
                       @change="validateAge" 
                       required>
              </div>
              <div class="mb-3">
                <label for="email" class="form-label">Email Address</label>
                <input type="email" 
                       class="form-control" 
                       v-model="email" 
                       @input="validateEmail" 
                       placeholder="Your email address" 
                       required>
                <div class="text-danger" v-if="emailError">{{ emailError }}</div>
                <div class="text-danger" v-if="emailInUseError">{{ emailInUseError }}</div> 
              </div>
              <div class="mb-3">
                <label for="password-1" class="form-label">Password</label>
                <input type="password" 
                       class="form-control" 
                       v-model="password1" 
                       @input="validatePassword" 
                       placeholder="Create a password" 
                       required>
                <div class="text-danger" v-if="passwordError">{{ passwordError }}</div>
              </div>
              <div class="mb-3">
                <label for="password-2" class="form-label">Confirm Password</label>
                <input type="password" 
                       class="form-control" 
                       v-model="password2" 
                       @input="validatePasswordMatch" 
                       placeholder="Confirm your password" 
                       required>
                <div class="text-danger" v-if="matchError">{{ matchError }}</div>
              </div>
              <div class="d-grid">
                <button type="submit" class="btn btn-dark">Sign Up</button>
              </div>
              <p class="text-center mt-3">Already have an account? <router-link to="/login">Log In</router-link></p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from '../router/axiosSetup';


export default {
  data() {
    return {
      username: '',
      firstName: '',
      lastName: '',
      birthDate: '',
      email: '',
      password1: '',
      password2: '',
      usernameError: '',
      firstNameError: '',
      lastNameError: '',
      emailError: '',
      emailInUseError: '',
      passwordError: '',
      matchError: '',
      usernameWarning: ''
    };
  },
  methods: {
    async register() {
      // Reset all errors
      this.resetErrors();
    
      // Validation checks
      const isValid = this.validateAll();
      console.log("IsValid: ", isValid);
      if (! isValid) {
        return; // Stop registration if validation fails
      }

      try {
        const response = await axiosInstance.post('/register', {
          username: this.username,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password1: this.password1,
          password2: this.password2,
        });

        alert(response.data.message); // Alert on successful registration
        this.$router.push('/login'); // Redirect after successful registration

      } catch (error) {
        if (error.response) {
          if (error.response.data.message) {
            alert(error.response.data.message); // Display server error message
          } else {
            alert('Registration failed. Please try again.'); // Generic error message
          }
        } else {
          console.error('Error during registration:', error);
        }
      }
    },

    resetErrors() {
      this.usernameError = '';
      this.firstNameError = '';
      this.lastNameError = '';
      this.emailError = '';
      this.emailInUseError = '';
      this.passwordError = '';
      this.matchError = '';
      this.usernameWarning = '';
    },

    validateAll() {
      let isValid = true;
      console.log("email:", this.email);
      console.log("PSW1:", this.password1);
      console.log("PSW2:", this.password2);
      if (this.password1 !== this.password2) {
        this.matchError = 'Passwords do not match.';
        isValid = false;
      }

      if (!this.validatePassword(this.password1)) {
        this.passwordError = 'Password must be 8-20 characters long, contain at least 1 uppercase letter, 1 lowercase letter, and 1 number.';
        isValid = false;
      }

      if (this.username.length < 5) {
        this.usernameError = 'Username must be at least 5 characters long.';
        isValid = false;
      }

      if (this.firstName.trim() === '') {
        this.firstNameError = 'First name is required.';
        isValid = false;
      }

      if (this.lastName.trim() === '') {
        this.lastNameError = 'Last name is required.';
        isValid = false;
      }

      if (!this.validateEmail(this.email)) {
        this.emailError = 'Please enter a valid email address.';
        isValid = false;
      }

      return isValid;
    },

    validateUsername() {
      if (this.username.trim() === '' || /^[a-zA-Z0-9_]+$/.test(this.username)) {
        this.usernameWarning = '';
        this.checkUsernameExists();
      } else {
        this.usernameWarning = 'Invalid characters used. Only Latin letters, numbers, and "_" are allowed.';
      }
    },

    async checkUsernameExists() {
      try {
        const response = await axiosInstance.get(`/check-username?username=${this.username}`);
        if (response.data.exists) {
          this.usernameWarning = 'Username is already taken.';
        } else {
          this.usernameWarning = '';
        }
      } catch (error) {
        console.error('Error checking username:', error);
      }
    },

    validateFirstName() {
      if (this.firstName.trim() === '') {
        this.firstNameError = 'First name is required.';
      } else {
        this.firstNameError = '';
      }
    },

    validateLastName() {
      if (this.lastName.trim() === '') {
        this.lastNameError = 'Last name is required.';
      } else {
        this.lastNameError = '';
      }
    },

    validateEmail() {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex

  if (!emailPattern.test(this.email)) {
    this.emailError = 'Please enter a valid email address.';
    this.emailInUseError = ''; // Clear existing error
    return false;
  } else {
    this.emailError = ''; // Clear email format error
    return this.checkEmailExists(); // Only check for existence if format is valid
  }
},

async checkEmailExists() {
  if (this.email.trim() !== '') {
    try {
      const response = await axiosInstance.get(`/check-email?email=${this.email}`);
      if (response.data.exists) {
        this.emailInUseError = 'This email is already in use.';
        return false;
      } else {
        this.emailInUseError = ''; // Clear error if email is available
        return true;
      }
    } catch (error) {
      console.error('Error checking email:', error);
    }
  }
},

     validatePassword() {
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$/; // Your password rules
    if (!passwordPattern.test(this.password1)) {
      this.passwordError = 'Password must be 8-20 characters long, contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and one special character.'; // Your error message
      return false;
    } else {
      this.passwordError = ''; // Clear error if valid
      return true;
    }
  },

    validatePasswordMatch() {
      if (this.password1 !== this.password2) {
        this.matchError = 'Passwords do not match.';
      } else {
        this.matchError = '';
      }
    },

    validateAge() {
       const birthDate = new Date(this.birthDate);
      const currentDate = new Date();
      let age = currentDate.getFullYear() - birthDate.getFullYear();
      const monthDifference = currentDate.getMonth() - birthDate.getMonth();

      // Adjust age if birthday hasn't occurred yet this year
      if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())) {
        age--;
      }

      if (age < 13) {
        alert('Parental consent is required for children under 13.');
        this.birthDate = "";  // Clear the field
        return false; // Prevent form submission
      }

      return true; // Valid age
    },
  },
};
</script>

<style scoped>
.text-danger {
  display: block;
}
</style>